import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_button = _resolveComponent("the-button")!
  const _component_button_dropdown = _resolveComponent("button-dropdown")!

  return (_openBlock(), _createBlock(_component_button_dropdown, {
    class: "w-min",
    icon: "fas fa-ellipsis-h",
    strategy: "fixed"
  }, {
    default: _withCtx(() => [
      (_ctx.isCanResendContract)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 0,
            loading: _ctx.state.is_dogovor_loading,
            class: "small primary text",
            onClick: _ctx.resendContract
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Переотправить договор ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanResendTo1C)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 1,
            loading: _ctx.state.is_1c_loading,
            class: "small primary text",
            onClick: _ctx.resendTo1C
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Переотправить в 1С ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      _createVNode(_component_the_button, {
        class: "small primary",
        onClick: _ctx.emitUpdate
      }, {
        default: _withCtx(() => [
          _createTextVNode(" Редактировать ")
        ]),
        _: 1
      }, 8, ["onClick"]),
      (_ctx.isCanSendToContract)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 2,
            loading: _ctx.state.is_send_loading,
            class: "small primary",
            onClick: _ctx.emitSend
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отправить список курьеров на подпись ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.carrier && _ctx.carrier.status_id !== 2)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 3,
            class: "text small primary",
            loading: _ctx.state.is_activate_loading,
            onClick: _ctx.emitActivate
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Активировать ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.carrier && _ctx.carrier.status_id !== 3)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 4,
            class: "text small red",
            loading: _ctx.state.is_deactivate_loading,
            onClick: _ctx.emitDeactivate
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Деактивировать ")
            ]),
            _: 1
          }, 8, ["loading", "onClick"]))
        : _createCommentVNode("", true),
      (_ctx.isCanTripartiteAgreement)
        ? (_openBlock(), _createBlock(_component_the_button, {
            key: 5,
            class: "text small primary",
            onClick: _ctx.emitTripartiteAgreement
          }, {
            default: _withCtx(() => [
              _createTextVNode(" Отправить 3-х сторонний договор ")
            ]),
            _: 1
          }, 8, ["onClick"]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}